import type { SVGProps } from 'react';
const SvgMenuBars = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Menu Bars Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M2.643 4.625h13.214M2.643 9.25h13.214M2.643 13.875h13.214" />
    </g>
  </svg>
);
export default SvgMenuBars;
